import { Component, OnDestroy, OnInit } from '@angular/core';
import { OffersValidCsvIface } from '../../../interfaces/offersValidCsv.iface';
import { OffersService } from '../../../services/offers.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-csv-import',
  templateUrl: './csv-import.component.html',
  styleUrls: ['./csv-import.component.scss']
})
export class CsvImportComponent implements OnInit, OnDestroy {
  public validationErrors: OffersValidCsvIface[];
  public subscription: Subscription;

  constructor(private offersService: OffersService) {}

  ngOnInit() {
    this.subscription = this.offersService.currentErrors.subscribe(errors => {
      this.validationErrors = errors;
    });
  }

  ngOnDestroy() {
    this.offersService.csvValidationInfo$.next([]);
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/csv-import/csv-import.component.ts